import { FormattedIntlCurrency as TypicalFormattedCurrency } from 'I18n/components/FormattedIntlCurrency';
import { jsx as _jsx } from "react/jsx-runtime";
const QUADRILLION = 1000000000000000;
const FormattedCurrency = ({
  currencyCode,
  value
}) => {
  if (value === null) {
    return null;
  }

  // If the value is greater than a quadrillion, use the light formatter
  // because it properly handles the abbreviation of the currency at that scale.
  if (value > QUADRILLION) {
    return /*#__PURE__*/_jsx(TypicalFormattedCurrency, {
      currencyCode: currencyCode,
      abbreviate: true,
      value: value
    });
  }

  // Otherwise, use the typical I18n formatter.
  return /*#__PURE__*/_jsx(TypicalFormattedCurrency, {
    abbreviate: true,
    currencyCode: currencyCode,
    maximumFractionDigits: 1,
    value: value
  });
};
export default FormattedCurrency;